"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadService = void 0;
const APIService_1 = require("./APIService");
const add = (leadType, body) => APIService_1.APIService.post(`/leads?type=${leadType}`, body);
const addOffer = (profileId, offerId, body) => APIService_1.APIService.post(`/profiles/${profileId}/leads?offerId=${offerId}`, body);
const verifyPhone = (leadId, code) => APIService_1.APIService.patch(`/leads/${leadId}/verify-phone?code=${code}`);
exports.LeadService = {
    add,
    addOffer,
    verifyPhone,
};
//# sourceMappingURL=LeadService.js.map